export const POSITION = {
  CLIENT: 1,
  PRODUCER: 2,
  SPECIALIST: 3,
};

/** API のポジション文字列を数値定数にマッピング */
export const POSITION_MAP = {
  CLIENT: POSITION.CLIENT,
  REVIEWER: POSITION.CLIENT,
  PRODUCER: POSITION.PRODUCER,
  DIRECTOR: POSITION.PRODUCER,
  SPECIALIST: POSITION.SPECIALIST,
  ADMIN: POSITION.PRODUCER,
};
